/**
 * Generated by orval v8.20.0 🍺
 * Do not edit manually.
 * Iaso
 * Iaso Swagger
 * OpenAPI spec version: v1
 */
import { z as zod } from 'zod';

export const AccountCustomTranslations = zod.strictObject({
    custom_translations: zod.unknown().nullable(),
});

export type AccountCustomTranslations = zod.input<
    typeof AccountCustomTranslations
>;
export type AccountCustomTranslationsOutput = zod.output<
    typeof AccountCustomTranslations
>;
